import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../../assets/Images/background.jpeg';
import '../../styles/CustomDesign.css';

const CustomDesign: React.FC = () => {
  const { t } = useTranslation();
  const features = t('customDesignPage.features', { returnObjects: true }) as Array<any>;
  const process = t('customDesignPage.process', { returnObjects: true }) as Array<any>;

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <motion.section 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="custom-design-hero"
      >
        <div className="absolute inset-0 bg-black/50 z-10" />
        <div className="absolute inset-0" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
        <div className="relative z-20 text-center text-white px-4">
          <motion.h1 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="custom-design-hero-title"
          >
            {t('customDesignPage.heroTitle')}
          </motion.h1>
          <motion.p 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="custom-design-hero-subtitle"
          >
            {t('customDesignPage.heroSubtitle')}
          </motion.p>
        </div>
      </motion.section>

      {/* Features Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="custom-design-features">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: index * 0.2 }}
                className="custom-design-feature-card"
              >
                <div className="custom-design-feature-icon">{feature.icon}</div>
                <h3 className="custom-design-feature-title">{feature.title}</h3>
                <p className="custom-design-feature-desc">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="custom-design-process-title">{t('customDesignPage.processTitle')}</h2>
          <div>
            {process.map((step, index) => (
              <motion.div
                key={index}
                initial={{ x: -20, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ delay: index * 0.2 }}
                className="custom-design-process-step"
              >
                <div className="custom-design-step-number">
                  {step.step}
                </div>
                <div className="custom-design-step-content">
                  <h3 className="custom-design-step-title">{step.title}</h3>
                  <p className="custom-design-step-desc">{step.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="custom-design-cta-section">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="custom-design-cta-title">{t('customDesignPage.ctaTitle')}</h2>
          <p className="custom-design-cta-desc">{t('customDesignPage.ctaDesc')}</p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="custom-design-cta-btn"
          >
            {t('customDesignPage.ctaButton')}
          </motion.button>
        </div>
      </section>
    </div>
  );
};

export default CustomDesign; 